var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"mb-10"},[_c('v-card-title',[_vm._v(" hommyTest ")]),_c('v-card-text',[_vm._v(" LALALAAAAA ")])],1),_c('v-card',[_c('v-row',[_c('v-col')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }